var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor"}},[_c('path',{attrs:{"d":"M5,5H10V7H7V10H5V5M14,5H19V10H17V7H14V5M17,14H19V19H14V17H17V14M10,17V19H5V14H7V17H10Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }